import { render, staticRenderFns } from "./HistoryCompanies.vue?vue&type=template&id=49a935c6"
import script from "./HistoryCompanies.vue?vue&type=script&lang=js"
export * from "./HistoryCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports